import { render } from "./ks-short-biography-photo.vue?vue&type=template&id=5ade6078"
import script from "./ks-short-biography-photo.vue?vue&type=script&lang=js"
export * from "./ks-short-biography-photo.vue?vue&type=script&lang=js"

import "./ks-short-biography-photo.vue?vue&type=style&index=0&id=5ade6078&lang=css"
script.render = render

export default script